module.exports = __webpack_public_path__ + "img/previewer_icon.09fe72ee.jpg";